export default "__VITE_ASSET__8437da4b__"